export default __webpack_public_path__ + "static/media/header-ico-plus.aec0e88d.svg";